export default __webpack_public_path__ + "static/061-9f29bcd765e63970c63a1ef6b8681913.jpg";